import { FC, ReactNode, useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { Colors, Dropdown, DropdownListItem } from '@brg/ui';

import {
  DropdownItemsWrapper,
  SlideNavigationItemsWrapper,
  SlideNavigationWrapperItem,
} from './styles';
import styled from 'styled-components';

const DropdownWrapper = styled.div`
  position: relative;
  
  svg {
    z-index: 0 !important;
  }
`;
import { SlideNavigationLayout } from './slideNavigationLayout';
import { TagsCoor, TagsPopUp } from '../TagsPopUp/TagsPopUp';
import { SlideWithHover } from './slideWithHover';
import {ScrollableSlideNavigationItems} from "./ScrollableSlideNavigationItems";
import useQueryState from 'shared/hooks/useQueryState';
import { MoreButton } from '../more-button';
import { useTranslation } from 'react-i18next';
import { ArrowCornerSvg } from 'shared/assets/16/ArrowCornerSvg';
import { AppTester } from "../../../supporting";
import { LayoutConst } from 'core';
import { useSelector } from 'react-redux';
import { ThemeSlideColorSelector } from 'shared/reducers/ThemeSlideColorSlice';
import { useRouteMatch } from 'react-router-dom';
// @ts-ignore
import { TFunctionResult } from 'i18next';
import { HoverContainer } from './components/HoverContainer';
import { useGetComputedSlides } from './hooks/useGetComputedSlides';
import { useScrollActiveTabIntoView } from './hooks/useScrollActiveTabIntoView';

//const MAX_ROW_COUNT = 4;
//const CUT_LAST_TAB = 3;
const INITIAL_ROW_COUNT = 10;
const SEARCH_BAR_WIDTH = 300;

type TSceletonProps = {
  col: string | number;
  w: number | string;
  h: number | string;
  gx: number
}

export type LinksItemRenderOptions = {
  isDropdown?: boolean;
};

export interface LinksItems {
  action: () => void;
  isLinks: boolean;
  element: ((options?: LinksItemRenderOptions) => ReactNode) | ReactNode;
}

export const renderLinksItem = (linkItem?: LinksItems, options?: LinksItemRenderOptions) => {
  if (!linkItem) return null;

  const { element } = linkItem;
  return typeof element === 'function' ? element(options) : element;
};

export interface SceletonProps {
  sceletonOptions?: TSceletonProps
}

export interface SlideNavigationProps extends SceletonProps {
  items?: Record<string, ReactNode | string | LinksItems | TFunctionResult>;
  onChange?: (indexKey: string) => void;
  activeIndexKey?: string;
  isLoading?: boolean;
  whiteTheme?: any;
  autoWidth?: boolean;
  autoFlex?: boolean;
  padding?: number;
  whiteSpace?: boolean;
  disableTab?: boolean;
  isSuperPuperGames?: boolean;
  isTitle?: boolean;
  overflowX?: boolean;
  isProfile?: boolean;
  capitalize?: boolean;
  blueSelect?: boolean;
  hoverPopup?: boolean;
  isDesigner?: boolean;
  hoverContent?: any;
  hoverDataName?: any;
  dropdownWhiteTheme?:any;
  stretch?: boolean;
  isDropdown?: boolean;
  arrowIconId?: string;
  fullWidth?: boolean;
  floatingTabs?:boolean;
  smallTab?: boolean;
  isCompetition?: boolean;
  customDropdownTheme?: any;
  maxVisibleItems?: number;
  onTagClick?: (data: any) => void;
  colors?: any;
  isLMSHomework?: boolean;
  noLeftPadding?: boolean;
  hasSortBar?: boolean;
  customGap?: string | number;
  showActiveTabUnderline?: boolean;
  forceMobile?: boolean;
  border?:string;
  activeUnderlineColor?: string;
}

const SlideNavigation: FC<SlideNavigationProps> = ({
  onChange,
  items,
  activeIndexKey,
  autoWidth,
  autoFlex,
  isLoading,
  whiteTheme,
  whiteSpace,
  padding,
  sceletonOptions,
  disableTab,
  isTitle,
  overflowX,
  capitalize,
  arrowIconId = '',
  blueSelect,
  hoverPopup,
  hoverContent,
  hoverDataName,
  isDesigner,
  stretch,
  fullWidth,
  dropdownWhiteTheme,
  smallTab,
  isCompetition,
  onTagClick,
  isLMSHomework,
  isSuperPuperGames,
  noLeftPadding,
  maxVisibleItems,
  customGap,
  showActiveTabUnderline = false,
  forceMobile,
  border,
  activeUnderlineColor
}) => {
  const tabsContainerRef = useRef<any>(null);
  const dropdownRef = useRef<HTMLDivElement>(null);
  const hoverPopUpRef = useRef<HTMLDivElement>(null);
  const { t, i18n } = useTranslation();
  const [pos,setPos] = useState<TagsCoor>({x: null, y: null });
  const [titleSize, setTitleSize] = useState(0)
  const [hoverElem, setHoverElem ] = useState<string | null>(null);
  const leaveTimeoutRef = useRef<NodeJS.Timeout | null>(null);
  const importantItemColor = useSelector(ThemeSlideColorSelector)?.slideColor;

  const activeTabRef = useRef<any>(null)
  const scrollContainerRef = useRef<any>(null)

  const slidesProps = {
    isDesigner,
    isLoading,
    items,
    activeTab: activeIndexKey,
    maxVisibleItems,
    isSuperPuperGames,
    forceMobile,
  }

  const { 
    onSetSizes,
    tabs,
    dropdownTabs
  } = useGetComputedSlides(slidesProps);

  useScrollActiveTabIntoView({
    activeIndexKey,
    isLoading,
    activeTabRef,
    tabsKeys: tabs ? Object.keys(tabs) : null,
    language: i18n.language,
    forceMobile,
  });

  const onChangeHandler = useCallback((key: string, isTest?: boolean) => (e: any) => {

    const targetRect = e?.target?.getBoundingClientRect()
    // console.log('TARGET', targetRect.left, scrollContainerRef.current, e.target.offsetLeft)

    const offset = Number(e.target.offsetLeft)

    setTimeout(() => {
      const container = document.querySelector('.slide-navigation-layout')
      // console.log('target left', offset, targetRect.right, targetRect, targetRect.width)
      if (container?.clientWidth && targetRect.right > container.clientWidth) {
        container?.scrollTo({left: (offset - container.clientWidth + targetRect.width)})
        return
      }
      if (container?.clientWidth && targetRect.left < 0) {
        container?.scrollTo({left: (offset)})
        return
      }
      // console.log('SCROLL NEUTRAL', offset, targetRect.left)
      container?.scrollTo({left: offset - targetRect.left})
    }, 0)
    

    onChange?.(key);
  }, [onChange]);

  const onSetHoverTab = useCallback((val: string | null) => {
    if (val !== null && leaveTimeoutRef.current) {
      clearTimeout(leaveTimeoutRef.current);
      leaveTimeoutRef.current = null;
    }
    
    if (val === null) {
      if (leaveTimeoutRef.current) {
        clearTimeout(leaveTimeoutRef.current);
      }
      leaveTimeoutRef.current = setTimeout(() => {
        setHoverElem(null);
        leaveTimeoutRef.current = null;
      }, 150);
    } else {
      setHoverElem(val);
    }
  }, [])

  useEffect(() => {
    return () => {
      if (leaveTimeoutRef.current) {
        clearTimeout(leaveTimeoutRef.current);
      }
    };
  }, [])


  useEffect(() => {
    if(tabsContainerRef?.current && hoverElem) {
      const el = tabsContainerRef.current?.querySelector(`[data-title="${hoverElem}"]`);
      const key = el?.dataset?.['title'];

      if (dropdownTabs && Object.keys(dropdownTabs)?.includes(key) && dropdownRef.current) {
        setPos({
          x: dropdownRef.current.offsetLeft || 0,
          y: el?.offsetTop
        });
        return;
      }
      if (el) {
        setPos({ x: el?.offsetLeft, y: 0 });
      }
    } 
    else if (!hoverElem) {
      setPos({ x: null, y: null });
    }
  }, [tabsContainerRef, hoverElem, dropdownTabs, dropdownRef])

  useEffect(() => {

    if (!dropdownTabs) return;

    const isDropdownOpen = dropdownRef.current?.querySelector('.show')

    const hasItemIntoDropdown = Object.keys(dropdownTabs)?.includes(hoverElem ?? '')

    if (hasItemIntoDropdown) return;

    if (hoverElem && isDropdownOpen) {
      isDropdownOpen?.classList.remove('show')
    }

  } , [dropdownRef?.current, hoverElem, dropdownTabs])

  const dropdown = useMemo(() => {

    if (!dropdownTabs) return null;

    return (
        <DropdownItemsWrapper
          isCompetition={isCompetition}
          //todo вынести выше или в тему
          isWhite={dropdownWhiteTheme}
          ref={dropdownRef}
          rightPos={titleSize > 8}
          leftPos={isLMSHomework && titleSize === 0}
        >
          <Dropdown
              hideArrow
              maxWidth={403}
              dark={whiteTheme}
              offsetX={Object.keys(tabs)?.length > 1? -180 : -160}
              orientation='left'
              {...(dropdownWhiteTheme && { maxHeight: 300 })}
              target={
                <MoreButton
                  onClick={() => setHoverElem(null)}
                />
              }
          >
            {Object.keys(dropdownTabs)?.map((item, idx, arr) => {
              
              // const isEmptyProjects = typeof dropdownTabs[item] === 'string' && dropdownTabs[item]?.split('|')[1]?.trim() === '0'
              // if (isEmptyProjects && item === 'discount') return null
              const isLink = typeof dropdownTabs[item] !== 'string';

              const dropdownItem = dropdownTabs[item] as string | LinksItems;

              return (
                  <DropdownListItem
                  //@ts-ignore
                    dataName={hoverDataName?.[item]}
                    data-title={item}
                    onMouseEnter={() => onSetHoverTab(item)}
                    isActive={item === activeIndexKey}
                    onClick={isLink ? dropdownTabs[item].action : onChangeHandler(item)}
                    key={idx}
                  >
                    {typeof dropdownItem === 'string'
                      ? dropdownItem.toLowerCase()
                      : renderLinksItem(dropdownItem, { isDropdown: true })}
                  </DropdownListItem>
              )
            })}
                  </Dropdown>
        </DropdownItemsWrapper>
    )
  } , [/*computedDropdownItems,*/dropdownTabs, onChangeHandler, activeIndexKey, hoverDataName, hoverContent, isCompetition, hoverElem, pos, blueSelect, dropdownWhiteTheme])

  const handleTagClick = useCallback((tagId: string) => {
    if (onTagClick) {
      onTagClick({ tagId, tab: hoverElem })
    }
  }, [hoverElem]);

  const onHoverPopupMouseEnter = useCallback(() => {
    if (leaveTimeoutRef.current) {
      clearTimeout(leaveTimeoutRef.current);
      leaveTimeoutRef.current = null;
    }
  }, []);

  const onHoverPopupMouseLeave = useCallback((event: MouseEvent) => {
    const relatedTarget = event.relatedTarget as Node;
    const currentTarget = event.currentTarget;

    //@ts-ignore
    if (relatedTarget instanceof Node && currentTarget && currentTarget.contains(relatedTarget)) {
      return;
    }

    onSetHoverTab(null)
  }, [onSetHoverTab]);

  const tabsComponent = useMemo(() => {
    if (hoverPopup && hoverContent && hoverDataName ) {
      return (
        <HoverContainer 
          hoverRef={hoverPopUpRef}
          onMouseEnter={onHoverPopupMouseEnter}
          onMouseLeave={onHoverPopupMouseLeave}
        >
        <SlideNavigationLayout
          autoWidth={autoWidth}
          autoFlex={autoFlex}
          isDesigner={isDesigner}
          isLoading={isLoading}
          activeTabRef={activeTabRef}
          containerRef={scrollContainerRef}
          border={border}
          content={
            tabs ? (
            <SlideNavigationItemsWrapper ref={tabsContainerRef} wrap="nowrap" wrapMobile="nowrap" offsetBottomMobile={activeUnderlineColor ? 0 : -4} isDesigner={isDesigner} overflowX={overflowX} $competitionMobileBaseline={isCompetition}>
              {Object.keys(tabs).map((key) => {
                const isLink = typeof items?.[key] !== 'string';
                return (
                  <SlideWithHover 
                    key={key}
                    tabKey={key}
                    forceMobile={forceMobile}
                    //@ts-ignore
                    onClick={isLink ? items[key]?.action : onChangeHandler(key)}
                    active={key === activeIndexKey}
                    whiteTheme={whiteTheme}
                    isDesigner={isDesigner}
                    blueSelect={blueSelect}
                    padding={padding}
                    whiteSpace={whiteSpace}
                    activeIndexKey={key}
                    disableTab={key !== activeIndexKey && disableTab}
                    isTitle={isTitle}
                    dataName={hoverDataName[key]}
                    dataTitle={key}
                    onSetSizes={onSetSizes}
                    onSetActiveTab={onSetHoverTab}
                    importantItemColor={importantItemColor}
                    //@ts-ignore
                    item={isLink ? renderLinksItem(items[key] as LinksItems) : capitalize ? items[key] : items[key]}
                    activeTabRef={activeTabRef}
                    noLeftPadding={noLeftPadding}
                    customGap={customGap}
                    competitionMobileUnderline={isCompetition}
                    showActiveTabUnderline={showActiveTabUnderline}
                    activeUnderlineColor={activeUnderlineColor}
                  />
                )
              })}
              {dropdown}
            </SlideNavigationItemsWrapper>
          ) : null
        }
          sceletonOptions={sceletonOptions}
        />
        <TagsPopUp 
          list={hoverContent} 
          currentTab={hoverElem} 
          visible={!!hoverElem} 
          coor={pos} 
          blueSelect={blueSelect} 
          onTagClick={onTagClick ? handleTagClick : undefined}
          onMouseEnter={onHoverPopupMouseEnter}
        />
      </HoverContainer>
      )
    }
    return (
      <SlideNavigationLayout
      autoWidth={autoWidth}
      autoFlex={autoFlex}
      isDesigner={isDesigner}
      isLoading={isLoading}
      stretch={stretch}
      fullWidth={fullWidth}
      activeTabRef={activeTabRef}
      containerRef={scrollContainerRef}
      border={border}
      content={
        tabs ? (
          <ScrollableSlideNavigationItems isDesigner={isDesigner} stretch={stretch} fullWidth={fullWidth} smallTab={smallTab} isTitle={isTitle} competitionMobileBaseline={isCompetition}>
            {Object.keys(tabs).sort((a, b) => a === 'competitionCerts' ? 1 : b === 'competitionCerts' ? -1 : 0).map((key, idx, arr) => {
              //@ts-ignore
              const isLink = typeof tabs[key] !== 'string';
              //@ts-ignore
              const isEmptyProjects = typeof tabs[key] === 'string' && tabs[key]?.split('|')[1]?.trim() === '0'
 
              return (
                /* @ts-ignore */
                <SlideWithHover
                  key={key}
                  forceMobile={forceMobile}
                  //@ts-ignore
                  onClick={isLink ? items[key]?.action : onChangeHandler(key)}
                  active={key === activeIndexKey}
                  activeIndexKey={key}
                  whiteTheme={whiteTheme}
                  isDesigner={isDesigner}
                  blueSelect={blueSelect}
                  padding={padding}
                  whiteSpace={whiteSpace}
                  disableTab={key !== activeIndexKey && disableTab}
                  isTitle={isTitle}
                  onSetSizes={onSetSizes}
                  isEmptyProjects={isEmptyProjects}
                  smallTab={smallTab}
                  noLeftPadding={noLeftPadding}
                  //@ts-ignore
                  item={isLink ? renderLinksItem(items[key] as LinksItems) : capitalize ? items[key] : items[key]}
                  customGap={customGap}
                  activeTabRef={activeTabRef}
                  competitionMobileUnderline={isCompetition}
                  showActiveTabUnderline={showActiveTabUnderline}
                  activeUnderlineColor={activeUnderlineColor}
                >
                {/*@ts-ignore*/}
                {isLink ? renderLinksItem(items[key] as LinksItems) : capitalize ? tabs[key] : tabs[key]}
                {arrowIconId === key && (
                  <ArrowCornerSvg clr={Colors.galBlack47} opacity={'1'} />
                )}
              </SlideWithHover>
              )
            })}
            <DropdownWrapper>
              {dropdown}
            </DropdownWrapper>
          </ScrollableSlideNavigationItems>
        ) : null
      }
      sceletonOptions={sceletonOptions}
    />
    )
  } , [
    tabs, 
    i18n.language, 
    hoverElem,
    pos,
    activeIndexKey,
    sceletonOptions,
    blueSelect,
    isDesigner,
    whiteTheme,
    isLoading,
    isCompetition,
    showActiveTabUnderline,
    activeUnderlineColor,
  ])

  return tabsComponent
};

export default SlideNavigation;
import { FC, ReactNode, useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { Colors, Dropdown, DropdownListItem } from '@brg/ui';

import {
  DropdownItemsWrapper,
  SlideNavigationItemsWrapper,
  SlideNavigationWrapperItem,
} from './styles';
import styled from 'styled-components';

const DropdownWrapper = styled.div`
  position: relative;
  
  svg {
    z-index: 0 !important;
  }
`;
import { SlideNavigationLayout } from './slideNavigationLayout';
import { TagsCoor, TagsPopUp } from '../TagsPopUp/TagsPopUp';
import { SlideWithHover } from './slideWithHover';
import {ScrollableSlideNavigationItems} from "./ScrollableSlideNavigationItems";
import useQueryState from 'shared/hooks/useQueryState';
import { MoreButton } from '../more-button';
import { useTranslation } from 'react-i18next';
import { ArrowCornerSvg } from 'shared/assets/16/ArrowCornerSvg';
import { AppTester } from "../../../supporting";
import { LayoutConst } from 'core';
import { useSelector } from 'react-redux';
import { ThemeSlideColorSelector } from 'shared/reducers/ThemeSlideColorSlice';
import { useRouteMatch } from 'react-router-dom';
// @ts-ignore
import { TFunctionResult } from 'i18next';
import { HoverContainer } from './components/HoverContainer';
import { useGetComputedSlides } from './hooks/useGetComputedSlides';
import { useScrollActiveTabIntoView } from './hooks/useScrollActiveTabIntoView';

//const MAX_ROW_COUNT = 4;
//const CUT_LAST_TAB = 3;
const INITIAL_ROW_COUNT = 10;
const SEARCH_BAR_WIDTH = 300;

type TSceletonProps = {
  col: string | number;
  w: number | string;
  h: number | string;
  gx: number
}

export type LinksItemRenderOptions = {
  isDropdown?: boolean;
};

export interface LinksItems {
  action: () => void;
  isLinks: boolean;
  element: ((options?: LinksItemRenderOptions) => ReactNode) | ReactNode;
}

export const renderLinksItem = (linkItem?: LinksItems, options?: LinksItemRenderOptions) => {
  if (!linkItem) return null;

  const { element } = linkItem;
  return typeof element === 'function' ? element(options) : element;
};

export interface SceletonProps {
  sceletonOptions?: TSceletonProps
}

export interface SlideNavigationProps extends SceletonProps {
  items?: Record<string, ReactNode | string | LinksItems | TFunctionResult>;
  onChange?: (indexKey: string) => void;
  activeIndexKey?: string;
  isLoading?: boolean;
  whiteTheme?: any;
  autoWidth?: boolean;
  autoFlex?: boolean;
  padding?: number;
  whiteSpace?: boolean;
  disableTab?: boolean;
  isSuperPuperGames?: boolean;
  isTitle?: boolean;
  overflowX?: boolean;
  isProfile?: boolean;
  capitalize?: boolean;
  blueSelect?: boolean;
  hoverPopup?: boolean;
  isDesigner?: boolean;
  hoverContent?: any;
  hoverDataName?: any;
  dropdownWhiteTheme?:any;
  stretch?: boolean;
  isDropdown?: boolean;
  arrowIconId?: string;
  fullWidth?: boolean;
  floatingTabs?:boolean;
  smallTab?: boolean;
  isCompetition?: boolean;
  customDropdownTheme?: any;
  maxVisibleItems?: number;
  onTagClick?: (data: any) => void;
  colors?: any;
  isLMSHomework?: boolean;
  noLeftPadding?: boolean;
  hasSortBar?: boolean;
  customGap?: string | number;
  showActiveTabUnderline?: boolean;
  forceMobile?: boolean;
  border?:string;
  activeUnderlineColor?: string;
}

const SlideNavigation: FC<SlideNavigationProps> = ({
  onChange,
  items,
  activeIndexKey,
  autoWidth,
  autoFlex,
  isLoading,
  whiteTheme,
  whiteSpace,
  padding,
  sceletonOptions,
  disableTab,
  isTitle,
  overflowX,
  capitalize,
  arrowIconId = '',
  blueSelect,
  hoverPopup,
  hoverContent,
  hoverDataName,
  isDesigner,
  stretch,
  fullWidth,
  dropdownWhiteTheme,
  smallTab,
  isCompetition,
  onTagClick,
  isLMSHomework,
  isSuperPuperGames,
  noLeftPadding,
  maxVisibleItems,
  customGap,
  showActiveTabUnderline = false,
  forceMobile,
  border,
  activeUnderlineColor
}) => {
  const tabsContainerRef = useRef<any>(null);
  const dropdownRef = useRef<HTMLDivElement>(null);
  const hoverPopUpRef = useRef<HTMLDivElement>(null);
  const { t, i18n } = useTranslation();
  const [pos,setPos] = useState<TagsCoor>({x: null, y: null });
  const [titleSize, setTitleSize] = useState(0)
  const [hoverElem, setHoverElem ] = useState<string | null>(null);
  const leaveTimeoutRef = useRef<NodeJS.Timeout | null>(null);
  const importantItemColor = useSelector(ThemeSlideColorSelector)?.slideColor;

  const activeTabRef = useRef<any>(null)
  const scrollContainerRef = useRef<any>(null)

  const slidesProps = {
    isDesigner,
    isLoading,
    items,
    activeTab: activeIndexKey,
    maxVisibleItems,
    isSuperPuperGames,
    forceMobile,
  }

  const { 
    onSetSizes,
    tabs,
    dropdownTabs
  } = useGetComputedSlides(slidesProps);

  useScrollActiveTabIntoView({
    activeIndexKey,
    isLoading,
    activeTabRef,
    tabsKeys: tabs ? Object.keys(tabs) : null,
    language: i18n.language,
    forceMobile,
  });

  const onChangeHandler = useCallback((key: string, isTest?: boolean) => (e: any) => {

    const targetRect = e?.target?.getBoundingClientRect()
    // console.log('TARGET', targetRect.left, scrollContainerRef.current, e.target.offsetLeft)

    const offset = Number(e.target.offsetLeft)

    setTimeout(() => {
      const container = document.querySelector('.slide-navigation-layout')
      // console.log('target left', offset, targetRect.right, targetRect, targetRect.width)
      if (container?.clientWidth && targetRect.right > container.clientWidth) {
        container?.scrollTo({left: (offset - container.clientWidth + targetRect.width)})
        return
      }
      if (container?.clientWidth && targetRect.left < 0) {
        container?.scrollTo({left: (offset)})
        return
      }
      // console.log('SCROLL NEUTRAL', offset, targetRect.left)
      container?.scrollTo({left: offset - targetRect.left})
    }, 0)
    

    onChange?.(key);
  }, [onChange]);

  const onSetHoverTab = useCallback((val: string | null) => {
    if (val !== null && leaveTimeoutRef.current) {
      clearTimeout(leaveTimeoutRef.current);
      leaveTimeoutRef.current = null;
    }
    
    if (val === null) {
      if (leaveTimeoutRef.current) {
        clearTimeout(leaveTimeoutRef.current);
      }
      leaveTimeoutRef.current = setTimeout(() => {
        setHoverElem(null);
        leaveTimeoutRef.current = null;
      }, 150);
    } else {
      setHoverElem(val);
    }
  }, [])

  useEffect(() => {
    return () => {
      if (leaveTimeoutRef.current) {
        clearTimeout(leaveTimeoutRef.current);
      }
    };
  }, [])


  useEffect(() => {
    if(tabsContainerRef?.current && hoverElem) {
      const el = tabsContainerRef.current?.querySelector(`[data-title="${hoverElem}"]`);
      const key = el?.dataset?.['title'];

      if (dropdownTabs && Object.keys(dropdownTabs)?.includes(key) && dropdownRef.current) {
        setPos({
          x: dropdownRef.current.offsetLeft || 0,
          y: el?.offsetTop
        });
        return;
      }
      if (el) {
        setPos({ x: el?.offsetLeft, y: 0 });
      }
    } 
    else if (!hoverElem) {
      setPos({ x: null, y: null });
    }
  }, [tabsContainerRef, hoverElem, dropdownTabs, dropdownRef])

  useEffect(() => {

    if (!dropdownTabs) return;

    const isDropdownOpen = dropdownRef.current?.querySelector('.show')

    const hasItemIntoDropdown = Object.keys(dropdownTabs)?.includes(hoverElem ?? '')

    if (hasItemIntoDropdown) return;

    if (hoverElem && isDropdownOpen) {
      isDropdownOpen?.classList.remove('show')
    }

  } , [dropdownRef?.current, hoverElem, dropdownTabs])

  const dropdown = useMemo(() => {

    if (!dropdownTabs) return null;

    return (
        <DropdownItemsWrapper
          isCompetition={isCompetition}
          //todo вынести выше или в тему
          isWhite={dropdownWhiteTheme}
          ref={dropdownRef}
          rightPos={titleSize > 8}
          leftPos={isLMSHomework && titleSize === 0}
        >
          <Dropdown
              hideArrow
              maxWidth={403}
              dark={whiteTheme}
              offsetX={Object.keys(tabs)?.length > 1? -180 : -160}
              orientation='left'
              {...(dropdownWhiteTheme && { maxHeight: 300 })}
              target={
                <MoreButton
                  onClick={() => setHoverElem(null)}
                />
              }
          >
            {Object.keys(dropdownTabs)?.map((item, idx, arr) => {
              
              // const isEmptyProjects = typeof dropdownTabs[item] === 'string' && dropdownTabs[item]?.split('|')[1]?.trim() === '0'
              // if (isEmptyProjects && item === 'discount') return null
              const isLink = typeof dropdownTabs[item] !== 'string';

              const dropdownItem = dropdownTabs[item] as string | LinksItems;

              return (
                  <DropdownListItem
                  //@ts-ignore
                    dataName={hoverDataName?.[item]}
                    data-title={item}
                    onMouseEnter={() => onSetHoverTab(item)}
                    isActive={item === activeIndexKey}
                    onClick={isLink ? dropdownTabs[item].action : onChangeHandler(item)}
                    key={idx}
                  >
                    {typeof dropdownItem === 'string'
                      ? dropdownItem.toLowerCase()
                      : renderLinksItem(dropdownItem, { isDropdown: true })}
                  </DropdownListItem>
              )
            })}
                  </Dropdown>
        </DropdownItemsWrapper>
    )
  } , [/*computedDropdownItems,*/dropdownTabs, onChangeHandler, activeIndexKey, hoverDataName, hoverContent, isCompetition, hoverElem, pos, blueSelect, dropdownWhiteTheme])

  const handleTagClick = useCallback((tagId: string) => {
    if (onTagClick) {
      onTagClick({ tagId, tab: hoverElem })
    }
  }, [hoverElem]);

  const onHoverPopupMouseEnter = useCallback(() => {
    if (leaveTimeoutRef.current) {
      clearTimeout(leaveTimeoutRef.current);
      leaveTimeoutRef.current = null;
    }
  }, []);

  const onHoverPopupMouseLeave = useCallback((event: MouseEvent) => {
    const relatedTarget = event.relatedTarget as Node;
    const currentTarget = event.currentTarget;

    //@ts-ignore
    if (relatedTarget instanceof Node && currentTarget && currentTarget.contains(relatedTarget)) {
      return;
    }

    onSetHoverTab(null)
  }, [onSetHoverTab]);

  const tabsComponent = useMemo(() => {
    if (hoverPopup && hoverContent && hoverDataName ) {
      return (
        <HoverContainer 
          hoverRef={hoverPopUpRef}
          onMouseEnter={onHoverPopupMouseEnter}
          onMouseLeave={onHoverPopupMouseLeave}
        >
        <SlideNavigationLayout
          autoWidth={autoWidth}
          autoFlex={autoFlex}
          isDesigner={isDesigner}
          isLoading={isLoading}
          activeTabRef={activeTabRef}
          containerRef={scrollContainerRef}
          border={border}
          content={
            tabs ? (
            <SlideNavigationItemsWrapper ref={tabsContainerRef} wrap="nowrap" wrapMobile="nowrap" offsetBottomMobile={activeUnderlineColor ? 0 : -4} isDesigner={isDesigner} overflowX={overflowX} $competitionMobileBaseline={isCompetition}>
              {Object.keys(tabs).map((key) => {
                const isLink = typeof items?.[key] !== 'string';
                return (
                  <SlideWithHover 
                    key={key}
                    tabKey={key}
                    forceMobile={forceMobile}
                    //@ts-ignore
                    onClick={isLink ? items[key]?.action : onChangeHandler(key)}
                    active={key === activeIndexKey}
                    whiteTheme={whiteTheme}
                    isDesigner={isDesigner}
                    blueSelect={blueSelect}
                    padding={padding}
                    whiteSpace={whiteSpace}
                    activeIndexKey={key}
                    disableTab={key !== activeIndexKey && disableTab}
                    isTitle={isTitle}
                    dataName={hoverDataName[key]}
                    dataTitle={key}
                    onSetSizes={onSetSizes}
                    onSetActiveTab={onSetHoverTab}
                    importantItemColor={importantItemColor}
                    //@ts-ignore
                    item={isLink ? renderLinksItem(items[key] as LinksItems) : capitalize ? items[key] : items[key]}
                    activeTabRef={activeTabRef}
                    noLeftPadding={noLeftPadding}
                    customGap={customGap}
                    competitionMobileUnderline={isCompetition}
                    showActiveTabUnderline={showActiveTabUnderline}
                    activeUnderlineColor={activeUnderlineColor}
                  />
                )
              })}
              {dropdown}
            </SlideNavigationItemsWrapper>
          ) : null
        }
          sceletonOptions={sceletonOptions}
        />
        <TagsPopUp 
          list={hoverContent} 
          currentTab={hoverElem} 
          visible={!!hoverElem} 
          coor={pos} 
          blueSelect={blueSelect} 
          onTagClick={onTagClick ? handleTagClick : undefined}
          onMouseEnter={onHoverPopupMouseEnter}
        />
      </HoverContainer>
      )
    }
    return (
      <SlideNavigationLayout
      autoWidth={autoWidth}
      autoFlex={autoFlex}
      isDesigner={isDesigner}
      isLoading={isLoading}
      stretch={stretch}
      fullWidth={fullWidth}
      activeTabRef={activeTabRef}
      containerRef={scrollContainerRef}
      border={border}
      content={
        tabs ? (
          <ScrollableSlideNavigationItems isDesigner={isDesigner} stretch={stretch} fullWidth={fullWidth} smallTab={smallTab} isTitle={isTitle} competitionMobileBaseline={isCompetition}>
            {Object.keys(tabs).sort((a, b) => a === 'competitionCerts' ? 1 : b === 'competitionCerts' ? -1 : 0).map((key, idx, arr) => {
              //@ts-ignore
              const isLink = typeof tabs[key] !== 'string';
              //@ts-ignore
              const isEmptyProjects = typeof tabs[key] === 'string' && tabs[key]?.split('|')[1]?.trim() === '0'
 
              return (
                /* @ts-ignore */
                <SlideWithHover
                  key={key}
                  forceMobile={forceMobile}
                  //@ts-ignore
                  onClick={isLink ? items[key]?.action : onChangeHandler(key)}
                  active={key === activeIndexKey}
                  activeIndexKey={key}
                  whiteTheme={whiteTheme}
                  isDesigner={isDesigner}
                  blueSelect={blueSelect}
                  padding={padding}
                  whiteSpace={whiteSpace}
                  disableTab={key !== activeIndexKey && disableTab}
                  isTitle={isTitle}
                  onSetSizes={onSetSizes}
                  isEmptyProjects={isEmptyProjects}
                  smallTab={smallTab}
                  noLeftPadding={noLeftPadding}
                  //@ts-ignore
                  item={isLink ? renderLinksItem(items[key] as LinksItems) : capitalize ? items[key] : items[key]}
                  customGap={customGap}
                  activeTabRef={activeTabRef}
                  competitionMobileUnderline={isCompetition}
                  showActiveTabUnderline={showActiveTabUnderline}
                  activeUnderlineColor={activeUnderlineColor}
                >
                {/*@ts-ignore*/}
                {isLink ? renderLinksItem(items[key] as LinksItems) : capitalize ? tabs[key] : tabs[key]}
                {arrowIconId === key && (
                  <ArrowCornerSvg clr={Colors.galBlack47} opacity={'1'} />
                )}
              </SlideWithHover>
              )
            })}
            <DropdownWrapper>
              {dropdown}
            </DropdownWrapper>
          </ScrollableSlideNavigationItems>
        ) : null
      }
      sceletonOptions={sceletonOptions}
    />
    )
  } , [
    tabs, 
    i18n.language, 
    hoverElem,
    pos,
    activeIndexKey,
    sceletonOptions,
    blueSelect,
    isDesigner,
    whiteTheme,
    isLoading,
    isCompetition,
    showActiveTabUnderline,
    activeUnderlineColor,
  ])

  return tabsComponent
};

export default SlideNavigation;
